import { Box, Flex, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import SkeletonComponent from 'UiKit/skeleton';
import PaginationSkeleton from 'Component/skeleton/pagination';
import { Iteration } from 'Component/others';

import styles from './styles.module.css';

const ApprovalRescheduleSkeleton = () => {
  return (
    <Box padding="32px 24px">
      <Flex mb="12px" className={styles['section__head']}>
        <SkeletonComponent height="28px" width="108px" mb="4px" />
      </Flex>

      <Flex className={styles['section__filter']}>
        <SkeletonComponent height="34px" width="337px" />
        <SkeletonComponent height="34px" width="140px" />
        <SkeletonComponent height="34px" width="164px" />
        <SkeletonComponent height="34px" width="120px" />
      </Flex>

      <Box className={styles['section__table']}>
        <Table className={styles['table__skeleton']}>
          <Thead>
            <Tr>
              <Th className={styles['skeleton__head']} width="120px">
                <Flex>
                  <SkeletonComponent height="21px" width="70%" />
                </Flex>
              </Th>
              <Th className={styles['skeleton__head']} width="180px">
                <Flex>
                  <SkeletonComponent height="21px" width="80%" />
                </Flex>
              </Th>
              <Th className={styles['skeleton__head']} width="150px">
                <Flex>
                  <SkeletonComponent height="21px" width="60%" />
                </Flex>
              </Th>
              <Th className={styles['skeleton__head']} width="150px">
                <Flex>
                  <SkeletonComponent height="21px" width="85%" />
                </Flex>
              </Th>
              <Th className={styles['skeleton__head']} width="240px">
                <Flex>
                  <SkeletonComponent height="21px" width="90%" />
                </Flex>
              </Th>
              <Th className={styles['skeleton__head']} width="150px">
                <Flex>
                  <SkeletonComponent height="21px" width="85%" />
                </Flex>
              </Th>
              <Th className={styles['skeleton__head']} width="100px">
                <Flex>
                  <SkeletonComponent height="21px" width="65%" />
                </Flex>
              </Th>
              <Th width="200px" className={styles['skeleton__head']}>
                <Flex justifyContent="center">
                  <SkeletonComponent height="21px" width="50%" />
                </Flex>
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            <Iteration
              items={[1, 2, 3, 4, 5, 6, 7]}
              render={(num) => {
                return (
                  <Tr key={num}>
                    <Td className={styles['skeleton__column']}>
                      <SkeletonComponent height="21px" width="80px" borderRadius="12px" />
                    </Td>

                    <Td className={styles['skeleton__column']}>
                      <SkeletonComponent height="21px" width="90%" />
                    </Td>

                    <Td className={styles['skeleton__column']}>
                      <SkeletonComponent height="21px" width="85%" />
                    </Td>

                    <Td className={styles['skeleton__column']}>
                      <SkeletonComponent height="21px" width="75%" />
                    </Td>

                    <Td className={styles['skeleton__column']}>
                      <SkeletonComponent height="21px" width="95%" />
                    </Td>

                    <Td className={styles['skeleton__column']}>
                      <SkeletonComponent height="21px" width="80%" />
                    </Td>

                    <Td className={styles['skeleton__column']}>
                      <SkeletonComponent height="21px" width="60px" borderRadius="4px" />
                    </Td>

                    <Td className={styles['skeleton__column']}>
                      <Flex gap="8px" justifyContent="center">
                        <SkeletonComponent height="32px" width="60px" borderRadius="6px" />
                        <SkeletonComponent height="32px" width="60px" borderRadius="6px" />
                      </Flex>
                    </Td>
                  </Tr>
                );
              }}
            />
          </Tbody>
        </Table>
      </Box>

      <Box className={styles['section__pagination--wrapper']}>
        <Box className={styles['section__pagination']}>
          <PaginationSkeleton />
        </Box>
      </Box>
    </Box>
  );
};

export default ApprovalRescheduleSkeleton;
